<script>
import fields from '@/components/fields/'
import BaseWidgetForm from "./BaseWidgetForm";

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        ...this.getCommonFields(),
        {
          fields: [
            new fields.Input({
              label: 'Kod',
              modelPath: [this, 'form', 'source'],
              required: true,
              type: 'textarea'
            }),
          ]
        }
      ]
    }
  }
}
</script>
